var smartHome = {
    //입점 브랜드 정보
    enterStoreDisplaySpaceId : 'DP_ENTER_STORE_INFO',
    //구매 시 유의사항
    buyNoticeDisplaySpaceId : 'DP_BUY_NOTICE',
    //KRP0008-2.0.0 : 구독 추천
    setSmartHomeRentalRecommand : function(){
        var modelId = lgePdpSendData.modelId !== null ? lgePdpSendData.modelId : "";
        var bizType = lgePdpSendData.bizType;
        var dpType = lgkorUI.parseUrl(location.href).searchParams.get("dpType");
        var smartHomeFlag = digitalData.productInfo.smart_home_flag;
        if(smartHomeFlag == 'Y' && bizType == 'PRODUCT' && dpType == 'careTab'){
            var param = {
                modelId : modelId,
                subCategoryId : lgePdpSendData.subCategoryId,
                bizType : bizType,
                dpType : dpType
            }
            $('#smartHomeRentalRecommandArea').empty();
            $.ajax({
                url: "/mkt/smartHome/"+modelId+"/rentalRecommend",
                type: "POST",
                data: JSON.stringify(param),
                async: false,
                contentType: "application/json; charset=UTF-8;",
                success: function(data) {
                    $('#smartHomeRentalRecommandArea').html(data);
                },
                error: function(e) {
                    console.log(e);
                }
            });
        }
    },
    //KRP0013 : 고객지원
    smartHomeSupport : function(){
        var smartHomeFlag = 'N';
        var manufactureCode;    //제조사코드
        var modelCode;
        if(digitalData.productInfo){
            smartHomeFlag = digitalData.productInfo.smart_home_flag;
            manufactureCode = digitalData.productInfo.manufacture_code;
            modelCode = digitalData.productInfo.model_sku;
        }else{
            return;
        }
        if(smartHomeFlag === 'Y' && manufactureCode != 'LGE'){
            var url = "/mkt/ajax/product/supportManufactureInfo";
            var param = "?manufactureCode=" + manufactureCode + "&modelCode=" + modelCode;
            $('.KRP0013').empty();
            $.ajax({
                url: url + param,
                type: "GET",
                data: null,
                cache : false,
                contentType : 'application/x-www-form-urlencoded; charset=UTF-8;',
                success: function(data) {
                    $('.KRP0013').html(data);
                    $('.KRP0013').buildCommonUI();
                },
                error: function(e) {
                    console.log(e);
                }
            });
        }
    },
    //전시구좌 조회
    getDisplaySpaceList : function(param,callback){
        var url = "/mkt/smartHome/"+param.modelId+"/displaySpace";
        $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(param),
            cache : false,
            contentType : 'application/json; charset=UTF-8;',
            success: function(r) {
                if(r){
                    if(typeof callback === 'function'){
                        callback(r.smartHomeDispSpaceHtml);
                    }
                }
            },
            error: function(e) {
                console.log(e);
            }
        });
    },
    //KRP0021 : 구매 시 유의사항
    smartHomeNotice : function(){
        var modelId;
        if(digitalData.productInfo){
            var smartHomeFlag = digitalData.productInfo.smart_home_flag;
            if(smartHomeFlag == 'Y'){
                modelId = digitalData.productInfo.model_id;
                smartHome.getDisplaySpaceList({
                    displaySpaceId : smartHome.buyNoticeDisplaySpaceId,
                    modelId : modelId
                }, function (r) {
                    $('.KRP0021').addClass("smart");
                    $('.KRP0021').find('.component-inner').html(r);
                    $('.KRP0021').buildCommonUI();
                });
            }
        }else{
            return;
        }
    },
    // KRP0013 AI HOME 추천영역
    smartComponentArea : function () {
        var modelId = "";

        var smartHomeFlag = 'N';
        var unifyIdInfo = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId;
        if(digitalData.productInfo){
            smartHomeFlag = digitalData.productInfo.smart_home_flag;
            modelId = digitalData.productInfo.model_id;
        }else{
            return;
        }

        var param = {
            unifyId : lgkorUI.stringToBool(loginFlag)?unifyIdInfo:""
        }
        //KRP0013 존재 여부 체크
        if($('#pdp_support').length > 0){
            $.ajax({
                url: "/mkt/smartHome/"+modelId+"/componentArea",
                type: "POST",
                data: JSON.stringify(param),
                async: false,
                contentType: "application/json; charset=UTF-8;",
                success: function(data) {
                    if(data.trim().length > 0 && $('#pdp_smartHome').length> 0){
                        $('#pdp_smartHome').show();
                        $('#pdp_smartHome').html(data);
                        $('#pdp_smartHome').buildCommonUI();
                        if (typeof _KRP0008 !== 'undefined') {
                            _KRP0008.refresh();
                        }

                        if(!vcui.detect.isMobile){
                            vcui.require(['ui/carousel'], function () {
                                $('#pdp_smartHome').find('.smart-set-wrap').vcCarousel({
                                    infinite: false,
                                    autoplay: false,
                                    swipeToSlide: true,
                                    slidesToShow: 4,
                                    slidesToScroll: 4,
                                    prevArrow:'.btn-arrow.prev',
                                    nextArrow:'.btn-arrow.next',
                                    adaptiveHeight: true,
                                });
                            });
                        }
                        $('#aiHomeTab').show()
                    }else{
                        $('#aiHomeTab').hide();
                    }
                },
                error: function(e) {
                    console.log(e);
                }
            });
        }
    }
}